export { default } from '@triptyk/ember-ui/components/loading-indicator.js';
